<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="chap"><a id="pl-5-4"></a><i><b>Are you ready to roll? Let’s start sewing with 2½˝ strips!</b></i></p>
<p class="noindentt">Years ago, when I first started sewing, precut fabrics weren’t a thing yet. To create a quilt I had to go to the fabric store, try my best to mix and match just the right prints—all while hefting big bolts of fabric into a tiny cart— and then I would wait in line for ages to get my yardage cut. Inevitably, I would then realize I’d completely forgotten something important! And then I would spend hours and hours cutting fabric strips to just the right size, which can be a challenge. So, when precut fabrics came around, I was definitely on board. They’re the best thing since sliced bread! These nifty little fabric bundles come in a variety of sizes for just about any quilt design you can imagine. I discovered 2½” strips, or jelly rolls, and these fabulous little bundles of precut fabric are a lifesaver. They help strip quilts come together in a snap!</p>
<p class="noindentt">Jelly rolls are the perfect precut for beginners because they’re so versatile and incredibly easy to work with. Simply unroll and start sewing! If you’re new to quilting, begin here and you’ll be amazed at what you can do with just one roll. Many of my very favorite quilt patterns start with 2½” strips.</p>
<p class="noindentt">Get inspired to use 2½” strips in new, creative ways with the latest Precut Companion book. The possibilities are endless! You can make anything you like with a lovely roll of precut 2½” strips. When you begin quilting with precut fabrics, it really couldn’t be any simpler! By the end of this book, you’ll feel educated and empowered to create your next quilt. Simply pick out a few of your favorite jelly rolls, sew along with these easy-to-follow patterns, and you’ll have a beautiful handmade quilt to snuggle up with in no time. And just try to stop at one jelly roll quilt. Before you know it, they’ll be calling you butter because you’ll be on a roll!</p>
<p class="noindentt">Happy Quilting!</p>
<p class="noindentt">Love,</p>
<p class="fig"><img src="images/5_2.jpg"/></p>
<p class="noindentl">Jenny Doan</p>
<p class="noindentl">Missouri Star Quilt Company</p>
<p class="noindentl"><a href="http://missouriquiltco.com" target="_blank">missouriquiltco.com</a></p>
<p class="fig"><img src="images/5_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0004_introduction-title.vue?62f379a6